module.exports = __webpack_public_path__ + "static/media/minbar.66a7f8f6.png";